import * as React from "react";
import {Box, Container, Divider, Heading, Link, Stack, Text} from "@chakra-ui/react";

const Support: React.FC = () => {
    return (
        <Box minH={"100dvh"} maxH={"100dvh"} overflowY={"auto"} bg={"gray.50"} py={{base: 10, md: 16}}>
            <Container maxW={"3xl"}>
                <Box bg={"white"} borderRadius={"xl"} borderWidth={"1px"} borderColor={"gray.200"} p={{base: 6, md: 10}} boxShadow={"sm"}>
                    <Stack spacing={6}>
                        <Box>
                            <Text fontSize={"xs"} letterSpacing={"0.3em"} textTransform={"uppercase"} color={"gray.500"}>
                                SoundSpots
                            </Text>
                            <Heading size={"lg"} mt={2}>Support</Heading>
                            <Text fontSize={"sm"} color={"gray.600"} mt={2}>
                                Need help with the SoundSpots app? You're in the right place.
                            </Text>
                        </Box>
                        <Divider/>
                        <Box>
                            <Heading size={"sm"} mb={2}>Contact us</Heading>
                            <Stack spacing={2} fontSize={"sm"} color={"gray.700"}>
                                <Text>
                                    Email{" "}
                                    <Link color={"blue.600"} href={"mailto:support@soundspots.com?subject=SoundSpots%20support"}>
                                        support@soundspots.com
                                    </Link>{" "}
                                    with your question and we'll get back to you.
                                </Text>
                                <Text>
                                    To help us answer quickly, please include:
                                </Text>
                                <Stack spacing={1} pl={4}>
                                    <Text>- The device and OS version you're using (e.g. iPhone 14, iOS 17).</Text>
                                    <Text>- The SoundSpots app version (shown on the app's launch screen).</Text>
                                    <Text>- The name of the space you were trying to load, if relevant.</Text>
                                    <Text>- A short description of what happened and what you expected.</Text>
                                </Stack>
                            </Stack>
                        </Box>
                        <Box>
                            <Heading size={"sm"} mb={2}>Common questions</Heading>
                            <Stack spacing={4} fontSize={"sm"} color={"gray.700"}>
                                <Box>
                                    <Text fontWeight={"semibold"}>Nothing happens when I scan a QR code.</Text>
                                    <Text>
                                        Make sure the SoundSpots app is installed and that your phone has Bluetooth turned
                                        on. If you scanned an older QR code, the app needs internet access the first time
                                        it loads the space; later, it works offline.
                                    </Text>
                                </Box>
                                <Box>
                                    <Text fontWeight={"semibold"}>The app says my space isn't compatible with iOS.</Text>
                                    <Text>
                                        Some spaces use MAC-based beacons that iOS can't read directly. Ask the person who
                                        set up the space to switch the affected spots to iBeacon-compatible beacons.
                                    </Text>
                                </Box>
                                <Box>
                                    <Text fontWeight={"semibold"}>I can't hear anything when I'm near a spot.</Text>
                                    <Text>
                                        Check that media volume is up, that the app has Bluetooth permission, and that
                                        you're physically close to the beacon. Battery-saver and Low Power Mode can also
                                        delay beacon detection.
                                    </Text>
                                </Box>
                                <Box>
                                    <Text fontWeight={"semibold"}>How do I delete my data?</Text>
                                    <Text>
                                        See the data deletion section of our{" "}
                                        <Link color={"blue.600"} href={"/privacy#data-deletion"}>Privacy Policy</Link>.
                                    </Text>
                                </Box>
                            </Stack>
                        </Box>
                        <Box>
                            <Heading size={"sm"} mb={2}>Documentation</Heading>
                            <Text fontSize={"sm"} color={"gray.700"}>
                                For admins who configure spaces, full documentation is available at{" "}
                                <Link color={"blue.600"} href={"https://docs.soundspots.app"} isExternal>
                                    docs.soundspots.app
                                </Link>.
                            </Text>
                        </Box>
                        <Text fontSize={"xs"} color={"gray.500"} pt={2}>
                            soundspots.app is owned, maintained, and operated by Jesper Lyng ApS (Pvt. Ltd.), DK
                        </Text>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
};

export default Support;
